import { createFileRoute, redirect } from '@tanstack/react-router'

// Хаб «Проекты и доски» переехал в drill-down «Компании» (/companies →
// /companies/$companyId). Роут оставлен redirect'ом — старые ссылки и закладки
// на /boards продолжают работать. Канбан доски живёт на /boards/$boardId.
export const Route = createFileRoute('/boards')({
  // `throw: true` — редирект бросается внутри router'а (жёсткий throw снаружи
  // ловит @typescript-eslint/only-throw-error: Redirect — не Error).
  beforeLoad: () => {
    redirect({ to: '/companies', throw: true })
  },
})
